import { useCallback, useEffect, useState } from "react"
import { getServerGroupList, serverGroupAddClient, serverGroupRemoveClient } from "../../services/tsQueryApis"
import MyModal from "../MyModal"
import { useSocket, useSocketEvent } from "../../contexts/SocketContext"
import { useAuth } from "../../lib/useAuth"

const ClientRanksModal = ({ server, client }) => {
    const { user } = useAuth()

    const { isConnected, sendMessage } = useSocket()
    const [isOpen, setIsOpen] = useState(false)
    const [serverGroupList, setServerGroupList] = useState(null)

    const toggleModal = () => {
        setIsOpen(!isOpen)
    }

    const handleSgList = useCallback((payload) => {
        const sgList = payload.map((sg) => {
            let has = false
            client.client_servergroups.split(",").includes(sg.sgid.toString()) && (has = true)
            return { ...sg, has }
        })

        setServerGroupList(sgList)
    })

    useSocketEvent("serverGroupList", handleSgList)

    useEffect(() => {
        isOpen && sendMessage("getServerGroupList", { client: client.client_database_id })
    }, [isOpen])

    return (
        <>
            <button onClick={toggleModal} className="styled-button px-2">
                رنک
            </button>
            <MyModal isOpen={isOpen} toggleModal={toggleModal} width="400px" height="400px">
                <div class="list flex-grow y-scroll">
                    <table>
                        <tbody>
                            {serverGroupList &&
                                serverGroupList.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td> {item?.name?.replaceAll("\\s", " ")}</td>
                                            <td className="text-left">
                                                <input
                                                    type="checkbox"
                                                    class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800  dark:bg-gray-700 dark:border-gray-600 focus:outline-none"
                                                    onClick={(e) => {
                                                        if (!item.has) {
                                                            sendMessage("serverGroupAdd", {
                                                                sgid: item.sgid,
                                                                cldbid: client.client_database_id,
                                                            })
                                                            setServerGroupList(() => {
                                                                let newServerGroupList = serverGroupList
                                                                newServerGroupList[index].has = true
                                                                return newServerGroupList
                                                            })
                                                        } else {
                                                            sendMessage("serverGroupRemove", {
                                                                sgid: item.sgid,
                                                                cldbid: client.client_database_id,
                                                            })
                                                            setServerGroupList(() => {
                                                                let newServerGroupList = serverGroupList
                                                                newServerGroupList[index].has = false
                                                                return newServerGroupList
                                                            })
                                                        }
                                                    }}
                                                    defaultChecked={item.has}
                                                />
                                            </td>
                                        </tr>
                                    )
                                })}
                        </tbody>
                    </table>
                </div>
            </MyModal>
        </>
    )
}

export default ClientRanksModal
